module.exports = __webpack_public_path__ + "img/hero-picture.fa9151c1.jpg";